/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import "./ArtworkHistoryModalEmptyState.scss";

export default function ArtworkHistoryModalEmptyState({
  isLoading,
  isUploadedState = false,
  isMade = false,
  ...restProps
}: any) {
  function emptyStateText() {
    if (isLoading) return "Loading...";
    if (isMade) return "No designs found.";
    if (isUploadedState) return "Previous transfers uploads will show here.";
    return "Previous transfers purchases will show here.";
  }

  function icon() {
    if (isUploadedState) return "upload-cloud";
    return "rebrand-carts";
  }

  const { className, ...otherAttrs } = restProps || {};

  return (
    <div className={cn("artwork-history-empty-state scope-82aa78a2", className)} {...otherAttrs}>
      <UseSvg
        className="artwork-history-empty-state__icon scope-82aa78a2"
        icon={icon()}
        data-testid="artwork-history-empty-state-icon"
      />
      <span className="scope-82aa78a2">{emptyStateText()}</span>
    </div>
  );
}

ArtworkHistoryModalEmptyState.displayName = "ArtworkHistoryModalEmptyState";
